import type { Reviews } from '@/scopes/products/user-reviews/types';
import type { ReviewsResponseMapper } from '@/scopes/products/user-reviews/infrastructure/api/reviews/reviewsResponseMapper';
import defaultFetch from 'isomorphic-unfetch';

import { createReviewsResponseMapper } from '@/scopes/products/user-reviews/infrastructure/api/reviews/reviewsResponseMapper';
import {
  createQueryStringSerializer,
  type QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer';

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string;
  };
  fetch: typeof defaultFetch;
  queryStringSerializer: QueryStringSerializer;
  reviewsResponseMapper: ReviewsResponseMapper;
}

export interface GetUserReviewsParameters {
  contextItemId: string;
  scoreSettingsId: string;
  sorting: string;
  showOnlyInWebsiteLanguage: boolean;
  partyCompositionGroupId: string;
  offset: number;
  limit: number;
}

export const createReviewsAPIClient = (dependencies: Partial<Dependencies> = {}) => {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    queryStringSerializer = createQueryStringSerializer(),
    reviewsResponseMapper = createReviewsResponseMapper(),
  } = dependencies as Dependencies;

  async function getUserReviews({
    contextItemId,
    scoreSettingsId,
    sorting,
    showOnlyInWebsiteLanguage,
    partyCompositionGroupId,
    offset,
    limit,
  }: GetUserReviewsParameters): Promise<Reviews> {
    const queryString = queryStringSerializer.serialize({
      contextItemId,
      scoreSettingsId,
      sorting,
      showOnlyInWebsiteLanguage,
      offset,
      travelertypes: partyCompositionGroupId,
      limit,
    });

    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/UserReviewsApi/GetUserReviews?${queryString}`);

    const data = await response.json();

    return reviewsResponseMapper.map(data);
  }

  return { getUserReviews };
};
